/* eslint-disable linebreak-style */
const animationInit = () => {
  const observerOptions = {};

  function animationCallback(entries) {
    entries.forEach((entry) => {
      const animatedState = entry.target?.dataset?.animatedState;
      const initialState = entry.target?.dataset?.initialState;
      if (entry.isIntersecting && animatedState) {
        entry.target.classList.add(`${animatedState}`);
        entry.target.classList.remove(`${initialState}`);
      }
    });
  }

  const AnimationObserver = new IntersectionObserver(
    animationCallback,
    observerOptions,
  );

  const animatedEls = document.querySelectorAll('[data-animated]');

  animatedEls.forEach((element) => {
    const initialState = element.dataset?.initialState;
    element.classList.add(`${initialState}`);
    AnimationObserver.observe(element);
  });
};

export default animationInit;
